import { Drawer, drawerClasses, SxProps, Toolbar, useTheme } from '@mui/material'

import { DRAWER_WIDTH } from 'common/constant'
import StyledWrap from 'components/StyledWrap'
import { useFlow } from 'utils/flow'
import { useCurrentPage } from 'utils/hook'
import { concatToSXProp } from 'utils/style'

import ContactSupport from './ContactSupport'
import Stepper from './Stepper'

const drawerStyle: SxProps = {
  width: DRAWER_WIDTH,
  flexShrink: 0,
  [`.${drawerClasses.paper}`]: {
    width: DRAWER_WIDTH,
    boxSizing: 'border-box',
    padding: '24px 32px',
    backgroundColor: '#FCFCFC',
  },
}

export default function Sidebar(): JSX.Element {
  const { data: flow } = useFlow()
  const { hide_progress_bar: hideDrawer } = flow!
  const currentPage = useCurrentPage()
  const { tags: currentPageTags } = currentPage
  const hideSidebarOnThisStep = currentPageTags.includes('hide_stepper')

  const theme = useTheme()

  return (
    <StyledWrap
      wrapCss={`position: relative; z-index: ${theme.zIndex.appBar - 1};`}
      elementName="Sidebar"
    >
      <Drawer
        disablePortal
        className="main-sidebar"
        variant="permanent"
        sx={concatToSXProp(drawerStyle, {
          display: {
            xs: 'none',
            sm: hideDrawer || hideSidebarOnThisStep ? 'none' : 'block',
          },
        })}
      >
        <Toolbar />
        <Stepper />
        <ContactSupport />
      </Drawer>
    </StyledWrap>
  )
}
